import { apiClient } from '../../../../core/api/client';

export type CreateReferralRequest = {
  providerId: string;
  clientIds: string[];
  profileViewEngagementId?: string;
  // Feature 102: required attestation + client-name opt-out (default on).
  attested: boolean;
  shareClientName?: boolean;
};

export type ReferralResponse = {
  success: boolean;
  referralsCreated: number;
  emailsSent: number;
  emailsFailed: number;
  message: string;
};

export type ReferralListItem = {
  id: string;
  clientId: string;
  providerId: string;
  referredAt: string;
  emailSent: boolean;
  emailSentAt?: string;
};

/**
 * Create provider referrals for selected clients
 * Feature 001: FA Dashboard Provider Referrals
 *
 * @param data - Provider ID and array of client IDs
 * @returns Referral creation response with counts
 * @throws Error if request fails
 */
export async function createReferrals(
  data: CreateReferralRequest,
): Promise<ReferralResponse> {
  const response = await apiClient.post<ReferralResponse>(
    '/advisors/referrals',
    data,
  );

  return response.data;
}

/**
 * Get existing referrals for a specific provider
 * Used to show "Already referred" state in UI
 *
 * @param providerId - Service Provider ID
 * @returns Array of existing referrals
 * @throws Error if request fails
 */
export async function fetchProviderReferrals(
  providerId: string,
): Promise<ReferralListItem[]> {
  const response = await apiClient.get<ReferralListItem[]>(
    `/advisors/referrals?providerId=${providerId}`,
  );

  return response.data;
}
